<template>
  <div class="AssetDetailed">
    <div class="main_top">当前资产明细</div>
    <div class="main_title">
      <div class="main_title_left">请手动输入查询条件进行查询</div>
      <div class="main_title_right">
        <span class="wenzi">条件</span>
        <a-select v-model:value="conditions" @change="handleChange" style="width:120px;">
          <a-select-option value="1">用户ID</a-select-option>
          <a-select-option value="2">注册电话</a-select-option>
        </a-select>
        <a-input class="bgm" style="width:160px" placeholder="通过手机号或ID筛选" v-model:value="RoomValue"/>
        <button @click="search({current:1,pageSize:paginationObj.pageSize})">查询</button>
      </div>
    </div>
    <a-table bordered :loading="tableloading" :columns="columns" :data-source="RoomData" :pagination="paginationObj" @change="search" :rowKey="(record,index)=>{return index}">
      <!-- <a slot="name" slot-scope="text">{{ text }}</a> -->
    </a-table>

  </div>
</template>
<script>
import { myMinxin } from "@/mixin"
import publics from '@/api/public'
import { queryAssetsDetail } from "@/api/api"
import { methodCallback } from '@/api/methodCallback'
import {notification} from 'ant-design-vue';
export default {
  name: "Person",
  mixins: [myMinxin],
  data() {
    return {
      conditions: '1', //条件下拉框
      RoomValue: '', //筛选输入框
      RoomData: [],
      paginationObj: {
        hideOnSinglePage: true,
        pageSize: 10,
        pageIndex: 1,
        total: 0,
        size: "small",
      },
      columns: publics.columns2,
      tableloading: false,
    }
  },
  computed: {

  },
  mounted() {
    //this.RechargeRecord({current:1,pageSize:this.paginationObj.pageSize})
  },
  methods: {
    search(pagination) {
      if (this.RoomValue === "") {
        let tipMessage;
        if (this.conditions === '1') {
          tipMessage = "请输入用户ID";
        } else {
          tipMessage = "请输入注册电话";
        }
        notification.warning({
          message: '警告！',
          description: tipMessage,
          duration: 2,
          key: "31",
          top: '20px',
        });
      }else{
        this.RechargeRecord(pagination)
      }
    },
    RechargeRecord(pagination) {
      let data = {
        pageIndex: pagination.current,
        PageSize: pagination.pageSize
      }
      if (this.conditions === '1') {
        data = { ...data, accountNO: this.RoomValue }
      }
      if (this.conditions === '2') {
        data = { ...data, phone: this.RoomValue }
      }
      queryAssetsDetail(data)
        .then((res) => {
          console.log(res)
          if (res.data.code === "SUCCESS") {
            this.tableloading = false;
            this.RoomData = res.data.data.collections;
            this.paginationObj.total = res.data.data.total;
          } else {
            methodCallback(res);
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    handleChange(value) {
      this.conditions = value
    },
  }
}
</script>
<style lang="less" scoped>
.AssetDetailed {
  background: #242526;
  height: 100%;
  border-radius: 4px;
  .main_top {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    text-indent: 30px;
    border-bottom: 1px solid #3f3f3f;
  }
  .main_title {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 0 30px;
    /deep/ .ant-select-arrow {
      color: rgba(255, 255, 255, 0.6) !important;
    }
    .main_title_left{
      color: #FFFFFF;
    }
    .main_title_right {
      .wenzi {
        font-size: 14px;
        color: #ffffff;
        margin-right: 15px;
      }
      /deep/ .ant-select-selector {
        background: #181818 !important;
        border: 1px solid #3f3f3f !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, 0.6);
      }
      .bgm {
        background: #181818 !important;
        border: 1px solid #3f3f3f !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 20px;
      }
      button {
        width: 80px;
        height: 30px;
        background: #1877f2;
        border: none;
        border-radius: 2px;
        cursor: pointer;
        color: #fff;
      }
    }
    ul {
      display: flex;
      li {
        margin-right: 30px;
        color: #ffffff;
        span {
          margin-right: 20px;
          font-size: 14px;
        }
        /deep/ .ant-input {
          width: 120px;
          height: 30px;
          border: 1px solid #626262;
          background: #181818;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
  /deep/ .ant-table-placeholder {
    background: #181818;
    border: 1px solid #242526;
    box-sizing: border-box;
  }
  /deep/ .ant-table {
    background: #242526;
  }
  /deep/ .ant-table-wrapper {
    box-sizing: border-box;
    padding: 20px 30px;
    .ant-table-content {
      border-radius: 6px;
      overflow: hidden;
    }
    .ant-table-bordered .ant-table-thead > tr > th,
    .ant-table-bordered .ant-table-tbody > tr > td {
      border-right: 1px solid #242526;
    }
    .ant-table-thead > tr > th {
      border-bottom: 1px solid #242526;
    }
    .ant-table-bordered .ant-table-header > table,
    .ant-table-bordered .ant-table-body > table,
    .ant-table-bordered .ant-table-fixed-left table,
    .ant-table-bordered .ant-table-fixed-right table {
      border: 1px solid #242526;
      border-right: 0;
      border-bottom: 0;
    }
    .ant-table-body {
      table {
        background: #181818;
        .ant-table-align-center {
          background: rgba(10, 10, 10, 0.8);
          color: #fff;
          padding: 3px;
          font-size: 14px;
        }
        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
          background: #181818 !important;
        }
        .ant-table-row {
          color: #fff;
          td {
            padding: 8px;
            background: #181818;
            border-bottom: 1px solid #242526;
            .ant-input-affix-wrapper {
              .ant-input {
                background: #181818 !important;
                color: #fff;
                text-align: center;
                border: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
